import { useEpisodeBeingEdited } from '@app/organisms/EpisodeEditForm/EpisodeEditFormContext';
import { FormattedMessage, useIntl } from 'react-intl';
import getSaveDraftEpisodeAndCloseSchema from '@app/organisms/EpisodeEditForm/schemas/saveDraftEpisodeAndCloseSchema';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import Button from '@ui/atoms/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import ExperimentalTooltip from '@ui/atoms/ExperimentalTooltip';
import { getDirtyValues } from '@/helpers';
import useSaveEpisodeFormMutation from '@app/organisms/EpisodeEditForm/helpers/useSaveEpisodeFormMutation';
import useInternalRouteMapping from '@hooks/useInternalRouteMapping.hook';
import EpisodeEditFormActionsTooltipMessage from '@app/organisms/EpisodeEditForm/actions/EpisodeEditFormActionsTooltipMessage';
import { getChaptersIdsRequiringImageDeletion } from '@app/organisms/EpisodeEditForm/helpers/getChaptersIdsRequiringImageDeletion';

const TransparentButton = styled(Button)`
    background: transparent;
`;

const SaveDraftEpisodeAndCloseButton = () => {
    const intl = useIntl();
    const { push } = useInternalRouteMapping();
    const {
        watch,
        reset,
        formState: { dirtyFields },
    } = useFormContext();
    const saveEpisodeFormMutation = useSaveEpisodeFormMutation();

    const episodeBeingEdited = useEpisodeBeingEdited();
    const schema = getSaveDraftEpisodeAndCloseSchema(intl);
    const formData = watch();
    const isSchemaValid = schema.isValidSync(formData);
    const isValid = isSchemaValid;

    const onPress = async () => {
        const dirtyValues = getDirtyValues(dirtyFields, formData);
        const chaptersIdsRequiringImageDeletion = getChaptersIdsRequiringImageDeletion(
            dirtyFields,
            formData.chapters,
        );

        const { content, options, privacy } = dirtyValues;
        const episodeData = { ...content, ...options, ...privacy };

        try {
            await saveEpisodeFormMutation.mutateAsync(
                {
                    episodeId: episodeBeingEdited.id,
                    episode: episodeData,
                    chapters: dirtyFields.chapters ? formData.chapters : null,
                    chaptersIdsRequiringImageDeletion,
                },
                {
                    onSuccess: () => {
                        reset();
                        push('menu.episodes');
                    },
                },
            );
        } catch (error) {
            // Error toast ?
        }
    };

    return (
        <ExperimentalTooltip
            isDisabled={isValid}
            content={<EpisodeEditFormActionsTooltipMessage isSchemaValid={isSchemaValid} />}
        >
            <TransparentButton
                variant="secondary"
                onPress={onPress}
                isDisabled={!isValid}
                isLoading={saveEpisodeFormMutation.isLoading}
                startIcon={
                    <FontAwesomeIcon
                        icon={icon({ name: 'check', style: 'regular' })}
                        color="inherit"
                    />
                }
            >
                <FormattedMessage defaultMessage="Enregistrer et fermer" />
            </TransparentButton>
        </ExperimentalTooltip>
    );
};

export default SaveDraftEpisodeAndCloseButton;
